import {
  deleteSSRCookie,
  getSSRCookie,
  setSSRCookie,
  TCookieOptions,
} from '@/common/cookies';
import jwtDecode from 'jwt-decode';
import { IAuthTokenCookie } from '@/modules/auth/types';
import { getEnvironmentDetails } from '@/utils/env';
import { getPasscodeAndAuthenticatorByUID } from '@/modules/auth/utils/passcode-authenticator';

const COOKIE_NAME = 'authToken';

export const setAuthToken = (
  context: TServerSideContext,
  value: Partial<IAuthTokenCookie>,
  options: TCookieOptions = {}
) => {
  const { isProductionEnvironment } = getEnvironmentDetails();

  const prevValue = (getAuthToken(context) || {}) as IAuthTokenCookie;

  //token
  const token: string = value?.token || prevValue?.token;
  if (!token) throw new Error('token is required');

  //uid
  const uid = value?.uid || prevValue?.uid || getUIDByToken(token);
  if (!uid) throw new Error('uid is required');
  value.uid = uid;

  if (!('isNeedPasscode' in value)) {
    //need to activate again
    value.isNeedPasscode = !!getPasscodeAndAuthenticatorByUID(context.req, uid);
  }

  //maxAge: need to prevent update cookie as session
  const expiresAt = +(value?.expiresAt || prevValue?.expiresAt);
  const maxAge = expiresAt
    ? (expiresAt - new Date().getTime()) / 1000
    : undefined;

  setSSRCookie(
    context.res,
    COOKIE_NAME,
    { ...prevValue, ...value },
    { maxAge, shouldUseCompression: !isProductionEnvironment, ...options }
  );
};

export const getAuthToken = (context: TServerSideContext) => {
  const { isProductionEnvironment } = getEnvironmentDetails();

  return getSSRCookie(context, COOKIE_NAME, {
    shouldUseCompression: !isProductionEnvironment,
  });
};

export const getAuthUID = (req: TServerSideRequest) => {
  return getSSRCookie(req, COOKIE_NAME)?.uid;
};

export const getUIDByToken = (token: string): string => {
  //todo:ask backend to return an uniqueID then remove this package
  const uid: string = token ? jwtDecode<any>(token)?.national_id : undefined;
  return uid;
};

export const deleteAuthToken = (res: TServerSideResponse) => {
  deleteSSRCookie(res, COOKIE_NAME);
};
